// extracted by mini-css-extract-plugin
module.exports = {"highlighted-title":"HighlightedTitle_highlighted-title__w9Ntw","highlighted-title-colored-text":"HighlightedTitle_highlighted-title-colored-text__ZSZyp"};